module.exports = __webpack_public_path__ + "img/1527636893.e584161e.jpg";